
import { Component, Vue } from 'vue-property-decorator';
import { handleStoreIntegrationCallback } from '../../helpers/eCommerce';
import { AddStorePayload, PlatformType } from '../../types';

@Component
export default class CallbackSquarespace extends Vue {
  get code(): string | null {
    return this.$route.query.code as string;
  }

  get state(): string | null {
    return this.$route.query.state as string;
  }

  async mounted() {
    if (!this.code || !this.state) return;

    const [nonce, shopURL] = this.state.split(',');

    const callbackURL = `https://${window.location.host}/ship/connect/ecommerce/callback/squarespace`;

    const payload: AddStorePayload = {
      platformType: PlatformType.SquareSpace,
      inputFields: [
        { fieldId: 'StoreUrl', value: shopURL },
        { fieldId: 'Code', value: this.code },
        { fieldId: 'Nonce', value: nonce },
        { fieldId: 'CallbackUrl', value: callbackURL },
      ],
    };

    await handleStoreIntegrationCallback(payload);
  }
}
